<div class="kiene-content-page">
    <mat-card>
        <div *ngIf="isLoading" class="kiene-loading-spinner">
            <mat-spinner *ngIf="isLoading"></mat-spinner>
        </div>
        <div class="kiene-table-header">
            <h3>Benutzerrollen</h3>
        </div>

        <div>
            <mat-form-field style="width: 100%">
                <mat-label>Benutzerrolle</mat-label>
                <input
                    #userroleInput
                    matInput
                    [formControl]="userroleCtrl"
                    [matAutocomplete]="autoUserrole"
                    placeholder="Benutzerrolle auswählen..."
                    (keydown.tab)="onUserroleTab($event)"
                    (keydown.enter)="onUserroleEnter($event)"
                />
                <mat-autocomplete
                    #autoUserrole="matAutocomplete"
                    [displayWith]="displayUserrole"
                    (optionSelected)="onUserroleSelected($event)"
                >
                    <mat-option
                        *ngFor="let u of filteredUserroles | async; let i = index"
                        [value]="u"
                        [class.userrole-tab-active]="tabCycleIndex === i"
                    >
                        {{ u.bezeichnung }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <h4 *ngIf="currentUserrole"> Benutzerrechte für Rolle {{ currentUserrole.bezeichnung }}: </h4>

        <mat-form-field *ngIf="currentUserrole" style="width: 100%">
            <mat-label>Benutzerrecht suchen</mat-label>
            <input
                #rightsSearchInput
                matInput
                [formControl]="rightsSearchCtrl"
                placeholder="Tab, Block oder Benutzerrecht eingeben..."
                (input)="onRightsSearchInput()"
                (keydown.enter)="onRightsSearchEnter($event)"
            />
            <button
                *ngIf="rightsSearchCtrl.value"
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Suche löschen"
                (click)="clearRightsSearch()"
            >
                <mat-icon>clear</mat-icon>
            </button>
        </mat-form-field>

        <p
            *ngIf="currentUserrole && getRightsSearchTerm() && !rightsSearchCycle.length"
            class="userrole-rights-search-empty"
        >
            Keine Benutzerrechte gefunden.
        </p>
        <p *ngIf="currentUserrole && getRightsSearchStatusText()" class="userrole-rights-search-hits">
            {{ getRightsSearchStatusText() }}
            <span *ngIf="getRightsSearchTotalMatches() > 1"> – Enter für nächsten Treffer</span>
        </p>

        <mat-accordion class="example-headers-align" [multi]="!!getRightsSearchTerm()">
            <mat-expansion-panel
                *ngFor="let m of visibleMenus; trackBy: trackMenuByName"
                [id]="getMenuElementId(m)"
                [disabled]="!currentUserrole"
                [expanded]="isMenuExpanded(m)"
                (opened)="onMenuOpened(m)"
                (closed)="onMenuClosed(m)"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ m }}
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ng-container *ngFor="let group of groups[m]">
                    <div *ngIf="isGroupVisible(m, group)">
                        <p
                            *ngIf="group"
                            class="userrole-group-title"
                            [class.userrole-group-highlighted]="isGroupHighlighted(m, group)"
                            [id]="getGroupElementId(m, group)"
                        >
                            {{ group }}
                        </p>
                        <ng-container *ngFor="let ur of actions[m + '-' + group]">
                            <span
                                *ngIf="isRightVisible(ur.benutzerrecht_id)"
                                class="userrole-right-item"
                                [class.userrole-right-highlighted]="isRightHighlighted(ur.benutzerrecht_id)"
                                [class.userrole-right-active]="isRightActive(ur.benutzerrecht_id)"
                                [id]="'userrole-right-' + ur.benutzerrecht_id"
                            >
                                <mat-checkbox
                                    style="margin-right: 12px"
                                    [(ngModel)]="userrightArray[ur.benutzerrecht_id]"
                                    (change)="setUserright($event, ur)"
                                >
                                    <span>{{ getRightActionLabel(ur) }} ({{ ur.benutzerrecht_id }})</span>
                                </mat-checkbox>
                            </span>
                        </ng-container>
                    </div>
                </ng-container>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card>
</div>
